module.exports = __webpack_public_path__ + "img/automation-icon-active.cc4276bc.svg";